import http from 'common/http'

import {
  addHeader,
  editHeaderDetails,
  headersFetched,
  removeHeader,
  headerTypesFetched,
} from 'actions/headers'

export const createHeaders = (data) => {
  return (dispatch) => {
    return http.post('/header', data).then((res) => {
      dispatch(addHeader(res.data))
      return res.data
    })
  }
}

export const getHeaders = () => {
  return (dispatch) => {
    return http.get('/header').then((res) => {
      dispatch(headersFetched(res.data))
    })
  }
}

export const editHeader = (id, data) => {
  return (dispatch) => {
    return http.put(`/header/${id}`, data).then((res) => {
      dispatch(editHeaderDetails(res.data))
      return res.data
    })
  }
}

export const deleteHeader = (id) => {
  return (dispatch) => {
    return http.delete(`/header/${id}`).then(() => {
      dispatch(removeHeader(id))
    })
  }
}

export const getHeaderTypes = () => {
  return (dispatch) => {
    return http.get('/header/types').then((res) => {
      dispatch(headerTypesFetched(res.data))
    })
  }
}
